/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PrimaryDiscographyRequestFieldFiltersInner } from './PrimaryDiscographyRequestFieldFiltersInner';
import {
    PrimaryDiscographyRequestFieldFiltersInnerFromJSON,
    PrimaryDiscographyRequestFieldFiltersInnerFromJSONTyped,
    PrimaryDiscographyRequestFieldFiltersInnerToJSON,
} from './PrimaryDiscographyRequestFieldFiltersInner';
import type { PrimaryDiscographyRequestSortFieldsInner } from './PrimaryDiscographyRequestSortFieldsInner';
import {
    PrimaryDiscographyRequestSortFieldsInnerFromJSON,
    PrimaryDiscographyRequestSortFieldsInnerFromJSONTyped,
    PrimaryDiscographyRequestSortFieldsInnerToJSON,
} from './PrimaryDiscographyRequestSortFieldsInner';

/**
 * 
 * @export
 * @interface PrimaryDiscographyRequest
 */
export interface PrimaryDiscographyRequest {
    /**
     * 
     * @type {number}
     * @memberof PrimaryDiscographyRequest
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof PrimaryDiscographyRequest
     */
    fromOffset?: number;
    /**
     * 
     * @type {string}
     * @memberof PrimaryDiscographyRequest
     */
    sortField?: PrimaryDiscographyRequestSortFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof PrimaryDiscographyRequest
     */
    sortOrder?: PrimaryDiscographyRequestSortOrderEnum;
    /**
     * 
     * @type {Array<PrimaryDiscographyRequestSortFieldsInner>}
     * @memberof PrimaryDiscographyRequest
     */
    sortFields?: Array<PrimaryDiscographyRequestSortFieldsInner>;
    /**
     * 
     * @type {object}
     * @memberof PrimaryDiscographyRequest
     */
    filters?: object;
    /**
     * 
     * @type {Array<PrimaryDiscographyRequestFieldFiltersInner>}
     * @memberof PrimaryDiscographyRequest
     */
    fieldFilters?: Array<PrimaryDiscographyRequestFieldFiltersInner>;
    /**
     * 
     * @type {string}
     * @memberof PrimaryDiscographyRequest
     */
    searchTerm?: string | null;
    /**
     * 
     * @type {Array<any>}
     * @memberof PrimaryDiscographyRequest
     */
    searchAfter?: Array<any>;
    /**
     * 
     * @type {string}
     * @memberof PrimaryDiscographyRequest
     */
    confidenceCategory?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrimaryDiscographyRequest
     */
    confidencePattern?: string | null;
}


/**
 * @export
 */
export const PrimaryDiscographyRequestSortFieldEnum = {
    EvidenceAvailable: 'evidence_available',
    ParentRecordingBandArtistNameRaw: 'parentRecording.bandArtistName.raw',
    ParentRecordingRecordingTitleRaw: 'parentRecording.recordingTitle.raw',
    ParentRecordingDuration: 'parentRecording.duration',
    ParentRecordingIsrcs: 'parentRecording.isrcs',
    ParentRecordingIsLive: 'parentRecording.isLive',
    ParentRecordingYearRecorded: 'parentRecording.yearRecorded',
    ParentRecordingRecordingVersion: 'parentRecording.recordingVersion',
    EarliestParentReleaseReleaseTitleRaw: 'earliestParentRelease.releaseTitle.raw',
    EarliestParentReleaseDateReleased: 'earliestParentRelease.dateReleased',
    EarliestParentReleaseMediaType: 'earliestParentRelease.mediaType',
    EarliestParentReleaseFormat: 'earliestParentRelease.format',
    EarliestParentReleaseReleaseLabels: 'earliestParentRelease.releaseLabels',
    EarliestParentReleaseCatNumbers: 'earliestParentRelease.catNumbers',
    PersonaStageName: 'persona.stageName',
    PerformanceFeaturedStatus: 'performance.featuredStatus',
    WestburyContributionsWestburyContribution: 'westburyContributions.westburyContribution',
    WestburyContributionsContribution: 'westburyContributions.contribution'
} as const;
export type PrimaryDiscographyRequestSortFieldEnum = typeof PrimaryDiscographyRequestSortFieldEnum[keyof typeof PrimaryDiscographyRequestSortFieldEnum];

/**
 * @export
 */
export const PrimaryDiscographyRequestSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type PrimaryDiscographyRequestSortOrderEnum = typeof PrimaryDiscographyRequestSortOrderEnum[keyof typeof PrimaryDiscographyRequestSortOrderEnum];


/**
 * Check if a given object implements the PrimaryDiscographyRequest interface.
 */
export function instanceOfPrimaryDiscographyRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "size" in value;

    return isInstance;
}

export function PrimaryDiscographyRequestFromJSON(json: any): PrimaryDiscographyRequest {
    return PrimaryDiscographyRequestFromJSONTyped(json, false);
}

export function PrimaryDiscographyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrimaryDiscographyRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'size': json['size'],
        'fromOffset': !exists(json, 'from_offset') ? undefined : json['from_offset'],
        'sortField': !exists(json, 'sort_field') ? undefined : json['sort_field'],
        'sortOrder': !exists(json, 'sort_order') ? undefined : json['sort_order'],
        'sortFields': !exists(json, 'sort_fields') ? undefined : ((json['sort_fields'] as Array<any>).map(PrimaryDiscographyRequestSortFieldsInnerFromJSON)),
        'filters': !exists(json, 'filters') ? undefined : json['filters'],
        'fieldFilters': !exists(json, 'field_filters') ? undefined : ((json['field_filters'] as Array<any>).map(PrimaryDiscographyRequestFieldFiltersInnerFromJSON)),
        'searchTerm': !exists(json, 'search_term') ? undefined : json['search_term'],
        'searchAfter': !exists(json, 'search_after') ? undefined : json['search_after'],
        'confidenceCategory': !exists(json, 'confidence_category') ? undefined : json['confidence_category'],
        'confidencePattern': !exists(json, 'confidence_pattern') ? undefined : json['confidence_pattern'],
    };
}

export function PrimaryDiscographyRequestToJSON(value?: PrimaryDiscographyRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'size': value.size,
        'from_offset': value.fromOffset,
        'sort_field': value.sortField,
        'sort_order': value.sortOrder,
        'sort_fields': value.sortFields === undefined ? undefined : ((value.sortFields as Array<any>).map(PrimaryDiscographyRequestSortFieldsInnerToJSON)),
        'filters': value.filters,
        'field_filters': value.fieldFilters === undefined ? undefined : ((value.fieldFilters as Array<any>).map(PrimaryDiscographyRequestFieldFiltersInnerToJSON)),
        'search_term': value.searchTerm,
        'search_after': value.searchAfter,
        'confidence_category': value.confidenceCategory,
        'confidence_pattern': value.confidencePattern,
    };
}

